import {memo} from 'react'

import {TableColumnsProvider} from '../../../../hooks/tanstack-table/providers/columns/table-columns-provider'
import {useVisibleFields} from '../../../../hooks/use-visible-fields'

export const TableColumnsProviderForTable = memo<{children: React.ReactNode}>(function TableColumnsProviderForTable({
  children,
}) {
  const {isFieldVisible} = useVisibleFields()
  return <TableColumnsProvider isFieldVisible={isFieldVisible}>{children}</TableColumnsProvider>
})
